import { render, staticRenderFns } from "./editExpenseType.vue?vue&type=template&id=4afb1690&scoped=true&"
import script from "./editExpenseType.vue?vue&type=script&lang=js&"
export * from "./editExpenseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afb1690",
  null
  
)

export default component.exports